export function ReturnBanner() {
  return (
    <a
      href="https://www.bevaneatts.com.au"
      className="return-banner"
      data-same-tab
      aria-label="Return to the main Bevan Eatts website"
    >
      <span className="return-banner__inner">
        ← Return to the main Bevan Eatts website
      </span>
    </a>
  );
}
